import { SHORTCUT_PRODUCT_GROUP_FIELDS } from '@@partner:graphql/shortcuts'
import { ProductGroup } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'


export interface ProductGroupInfoInput {
  id?: GQL_ID
  name: string
  label: string
  type: string
  brand_id :GQL_ID
  customerid: GQL_ID
}

export interface SaveProductGroup {
  productGroup: ProductGroup
}

export interface SaveProductGroupVariables {
  productGroupInfo: ProductGroupInfoInput
}

export const GQL_MUTATION_SAVE_PRODUCT_GROUP = gql`
  mutation saveProductGroup ($productGroupInfo: ProductGroupInfo) {
    productGroup: saveProductGroup(productGroupInfo: $productGroupInfo) {
      ${SHORTCUT_PRODUCT_GROUP_FIELDS}
    }
  }
`

export const useMutateSaveProductGroup = () => useMutation<SaveProductGroup, SaveProductGroupVariables>(
  GQL_MUTATION_SAVE_PRODUCT_GROUP
)